import React from 'react';
import CustomTooltip from '../../hooks/ToolTip';

export const HeadMiEmpresa = (props) => {
	const {TipoNotificaciones, cambioNotificaciones} = props;

	return (
		<div className='headUserFeedback'>
			<div className='superiorHeadContentUsuarios columnas3'>
				<div>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='40'
						height='40'
						fill='currentColor'
						className='bi bi-briefcase'
						viewBox='0 0 16 16'
					>
						<path d='M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z' />
					</svg>
				</div>
				<div className='centrador titleHeadHistorialFacturas'>
					<b>Mi Empresa</b>
				</div>
				<CustomTooltip textContent={"Gestiona o edita tus datos de empresa desde aquí."}/>
			</div>
			<div className='separador' />
			<div className='menuUserFeedback BotonesSuperiorPresupuestos'>
				<div
					className={TipoNotificaciones[0][0]}
					onClick={() => cambioNotificaciones(0)}
				>
					<div className='centrador'>{TipoNotificaciones[0][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[1][0]}
					onClick={() => cambioNotificaciones(1)}
				>
					<div className='centrador'>{TipoNotificaciones[1][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[2][0]}
					onClick={() => cambioNotificaciones(2)}
				>
					<div className='centrador'>{TipoNotificaciones[2][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[3][0]}
					onClick={() => cambioNotificaciones(3)}
				>
					<div className='centrador'>{TipoNotificaciones[3][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[4][0]}
					onClick={() => cambioNotificaciones(4)}
				>
					<div className='centrador'>{TipoNotificaciones[4][1]}</div>
				</div>
				<div
					className={TipoNotificaciones[5][0]}
					onClick={() => cambioNotificaciones(5)}
				>
					<div className='centrador'>{TipoNotificaciones[5][1]}</div>
				</div>
			</div>

		</div>
	);
};
